export async function domIsReady() {
  if (['complete', 'interactive'].includes(document.readyState)) {
    return Promise.resolve()
  }
  else {
    return new Promise(function(resolve) {
      document.addEventListener('readystatechange', function onReadyStateChange() {
        if (['complete', 'interactive'].includes(document.readyState)) {
          resolve()
          document.removeEventListener('readystatechange', onReadyStateChange)
        }
      })
    })
  }
}
